import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { parse, parseISO, isValid } from 'date-fns';

@Pipe({
  name: 'dateFormatPipe',
  standalone: true,
})
export class DateFormatPipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform(value: any, format: string = 'MMM d, y'): string | null {
    if (!value) {
      return null;
    }

    let date;
    
    if (typeof value === 'string') {
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        date = parseISO(value); // Handles 'yyyy-MM-dd'
      } else {
        date = parse(value, 'dd-MM-yyyy', new Date());
      }
    } else {
      date = new Date(value);
    }
    
    if (!isValid(date)) {
      console.warn(`Invalid date value: ${value}`);
      return value;
    }

    return this.datePipe.transform(date, format) || value;
  }
}